import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCriminal = async (params: object) => {
  return await GET({ url: Api.queryCriminal, params, showError: false })
}
export const getIsExistDdbit = async (params: object) => {
  return await GET({ url: Api.getIsExistDdbit, params, showError: false, headers: { 'Client-Id': 'iss_courier', rpcType: 'dubbo' } })
}
